// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__JgP8m {
    padding: 50px;
}

.centeredContainer__ZRJh0 {
    align-items: center;
    display: flex;
    justify-content: center;
}

.logo__e5jQi {
    width: 220px;
}

.logo__e5jQi svg {
    height: inherit;
    width: inherit;
}

.title__CqFWW {
    text-align: center;
    font-size: xx-large;
}`, "",{"version":3,"sources":["webpack://./src/components/ErrorFallback/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".container {\n    padding: 50px;\n}\n\n.centeredContainer {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n.logo {\n    width: 220px;\n}\n\n.logo svg {\n    height: inherit;\n    width: inherit;\n}\n\n.title {\n    text-align: center;\n    font-size: xx-large;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__JgP8m`,
	"centeredContainer": `centeredContainer__ZRJh0`,
	"logo": `logo__e5jQi`,
	"title": `title__CqFWW`
};
module.exports = ___CSS_LOADER_EXPORT___;
